import Request from '../data/request'

export default class ApiGantt {

    constructor() {

    }

    updateItems(items: any[]) {
        return new Request(this,'put','timeline/update',{
            data: items
        });
    }

}